<template>
  <div class="school-test-modal school-test-modal--hidden" id="modal-school" role="dialog" aria-modal="true" aria-labelledby="modal-school-title">
    <div class="school-test-modal__dialog" role="document">
      <template v-if="!isIntermediateResult">
        <div class="school-test-modal__header">
          <h2 class="school-test-modal__title" id="modal-school-title">Снова в школу с Асоль!</h2>
        </div>
        <div class="school-test-modal__subtitle">
          Помогите Асоль собрать школьный портфель мечты современного IT-школьника и пройти все испытания, заработав диплом «IT-знатока».
        </div>
      </template>
      <template v-if="step <= lastStepIdx">
        <template v-if="!isIntermediateResult">
          <div class="school-test-modal__question">{{ tests[step].question }}</div>
          <div class="school-test-modal__form">
            <ul class="school-test-modal__options">
              <li v-for="(variant, i) in tests[step].variants" :key="i" class="school-test-modal__option check">
                <label class="check__label">
                  <input class="check__input" type="checkbox" :name="i" v-model="currentStepAnswers[i]">
                  <span class="check__box" aria-hidden="true"></span>
                  <span class="check__text">{{ variant }}</span>
                </label>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <template v-if="userAnswers[step]">
            <div class="school-test-modal__result-step">
              <div class="school-test-modal__result-icon success" aria-hidden="true">
                <img src="/dist/img/school-test/Success.svg" alt="success">
              </div>
              <p class="school-test-modal__result-title">Верно!</p>
              <p class="school-test-modal__result-subtitle">Вы настоящий знаток ИТ-индустрии! <br> Держите награду!</p>
            </div>
          </template>
          <template v-else>
            <div class="school-test-modal__result-step">
              <div class="school-test-modal__result-icon error" aria-hidden="true">
                <img src="/dist/img/school-test/Error.png" alt="error">
              </div>
              <p class="school-test-modal__result-title">Упс!</p>
              <p class="school-test-modal__result-subtitle">Ошибочка вышла :(  <br> Не переживайте, у вас еще все впереди!</p>
            </div>
          </template>
        </template>
      </template>
      <template v-else>
        <div class="school-test-modal__test-result">
          <template v-if="isSuccessTest()">
            <p class="school-test-modal__test-result-smile">:)</p>
            <p class="school-test-modal__test-result-text">Вы набрали {{ countAchievments }} из 5! <br> Асоль будет лучшей ученицей в ИТ-школе, а все благодаря вам...и Паше.</p>
          </template>
          <template v-else>
            <p class="school-test-modal__test-result-smile">:(</p>
            <p class="school-test-modal__test-result-text">Вы набрали {{ countAchievments }} из 5! <br> Где-то грустит одна Асоль, а вы всегда можете попробовать сыграть еще раз.</p>
          </template>
        </div>
      </template>
      <footer class="school-test-modal__footer">
        <div class="school-test-modal__progress progress">
          <ul class="progress__list">
            <li v-for="(achIcon, i) in achievmentIcons" :key="i" class="progress__item">
              <img class="progress__coin" :src="achIcon" :alt="`Заработана монета за ${i + 1} вопрос`" :data-has="`${!!userAnswers[i]}`" />
            </li>
          </ul>
        </div>
        <div v-if="step <= lastStepIdx" class="school-test-modal__btn-wrapper">
          <img
              v-if="tests[step]"
              class="school-test-modal__step-icon"
              :class="`img-asol-${step + 1}`"
              :src="tests[step].stepIcon"
              alt="Иконка шага"
          >
          <button class="school-test-modal__next t-btn _green" @click="handleNextStep">Далее</button>
        </div>
        <button v-else class="school-test-modal__again t-btn _green" @click="handleAgainTest">Еще раз</button>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'school-test',
    data() {
      return {
        step: 0,
        lastStepIdx: 4,
        countAchievments: 0,
        isIntermediateResult: false,
        currentStepAnswers: [],
        userAnswers: [],
        successAnswers: [
          [true, true, false, false],
          [true, true, true, false],
          [true, false, false, false, false],
          [false, true, false, false],
          [true, true, true, true]
        ],
        achievmentIcons: [
          '/dist/img/school-test/1ach.png',
          '/dist/img/school-test/2ach.png',
          '/dist/img/school-test/3ach.png',
          '/dist/img/school-test/4ach.png',
          '/dist/img/school-test/5ach.png',
        ],
        tests: [
          {
            id: 1,
            question: 'Один из главных векторов атаки (по статистике последних лет) - это Фишинг. Какие действия необходимо предпринять,  чтобы минимизировать риски проникновения в инфраструктуру?',
            variants: [
              'Повышать ИБ грамотность сотрудников',
              'Включить двухфакторную аутентификацию',
              'Позвонить Паше',
              'Ничего не делать',
            ],
            stepIcon: '/dist/img/school-test/asol.png',
          },
          {
            id: 2,
            question: ' Что должен сделать ИБ-директор компании после устранения кибератаки?',
            variants: [
              'Усилить ИБ инфраструктуру (MDR, EDR, бекап)',
              'Обучить ИБ-грамотности сотрудников',
              'Поменять пароль у генерального директора',
              'Уволиться',
            ],
            stepIcon: '/dist/img/school-test/asol_02.png',
          },
          {
            id: 3,
            question: 'Что нужно сделать если решение класса Network Attack Discovery обнаружили уязвимости: ProxyLogon и ProxyShell — в почтовых серверах Microsoft Exchange?',
            variants: [
              'Обновить ПО',
              'Купить антивирус',
              'Снова позвонить Паше',
              'Не забивать на анализ трафика',
            ],
            stepIcon: '/dist/img/school-test/asol_03.png',
          },
          {
            id: 4,
            question: 'Как правильно переводится Mandatory Access?',
            variants: [
              'Мандатный доступ',
              'Обязательный доступ',
              'Понедельничный доступ',
              'Доступ в никуда',
            ],
            stepIcon: '/dist/img/school-test/asol_04.png',
          },
          {
            id: 5,
            question: 'Что крайне важно аналитику SOC?',
            variants: [
              'Mощный SIEM',
              'Зрелые playbook-и',
              'Кофемашина',
              'Холодная голова и ноги в тепле',
            ],
            stepIcon: '/dist/img/school-test/asol_05.png',
          }
        ],
      }
    },
    created() {
      const parsedUserAnswers = JSON.parse(localStorage.getItem('AxSchoolTest'))

      if (parsedUserAnswers) {
        let persistentCountAchievments = 0
        for (let i = 0; i < parsedUserAnswers.length; i++) {
          this.userAnswers[i] = parsedUserAnswers[i]
          if (parsedUserAnswers[i]) persistentCountAchievments++
        }

        this.countAchievments = persistentCountAchievments
        this.step = parsedUserAnswers.length
      }
    },
    methods: {
      isSuccessTest() {
        return this.countAchievments >= 4
      },
      handleAgainTest() {
        this.step = 0
        this.currentStepAnswers = []
        this.setUserAnswer([])
      },
      handleNextStep() {
        if (this.isIntermediateResult) {
          this.step++
          this.isIntermediateResult = false
          this.currentStepAnswers = []
        } else if (this.step === this.lastStepIdx) {
          this.checkStepResult()
          this.countAchievments = this.userAnswers.filter($ => $).length
          this.step++
        } else {
          this.checkStepResult()
          this.isIntermediateResult = true
        }
      },
      checkStepResult() {
        if (!this.currentStepAnswers.length) {
          this.setUserAnswerStep(false)
          return
        }

        const checkRes = this.successAnswers[this.step]?.every((v, i) => {
          if (v) return this.currentStepAnswers[i] === true
          else return this.currentStepAnswers[i] !== true
        })

        this.setUserAnswerStep(checkRes)
      },
      setUserAnswerStep(value) {
        this.userAnswers[this.step] = value
        localStorage.setItem('AxSchoolTest', JSON.stringify(this.userAnswers))
      },
      setUserAnswer(value) {
        this.userAnswers = value
        localStorage.setItem('AxSchoolTest', JSON.stringify(this.userAnswers))
      },
    }
  }
</script>

<style lang="sass">
.t-modal__container
  @media screen and (min-width: 921px)
    overflow: unset !important

.school-test-modal
  --brand: #00B0BD

  max-width: 980px

  &__dialog
    padding: 0 24px 20px

    @media screen and (max-width: 920px)
      display: flex
      flex-direction: column

  &__title
    font-size: 40px
    font-weight: 600
    line-height: 44px
    padding-right: 15px

    @media screen and (max-width: 920px)
      font-size: 24px

  &__subtitle
    font-size: 18px
    margin-top: 9px
    max-width: 692px

    @media screen and (max-width: 920px)
      margin-top: 14.5px
      font-size: 16px

  &__question
    font-size: 18px
    font-weight: 700
    margin-top: 25px
    max-width: 819px

    @media screen and (max-width: 920px)
      order: 2
      font-size: 16px
      margin-top: 42px

  &__form
    margin-top: 25px

    @media screen and (max-width: 920px)
      order: 3
      margin-top: 30px

  &__options
    display: flex
    flex-direction: column
    gap: 31px
    width: 100%
    list-style: none

    @media screen and (max-width: 920px)
      gap: 17px

  &__result
    &-icon
      display: flex
      align-items: center
      justify-content: center
      border-radius: 50%
      width: 99px
      height: 99px

      &.success
        background-color: #00B0BD

      &.error
        background-color: #EC7C7C

    &-title
      margin-block: 32px 17px
      font-size: 28px
      font-weight: 600

    &-subtitle
      font-size: 18px

  &__footer
    display: flex
    justify-content: space-between
    flex-wrap: wrap
    gap: 20px
    margin-top: 30px

    @media screen and (max-width: 920px)
      display: contents

  &__progress
    margin-top: 26px

    @media screen and (max-width: 920px)
      order: 1

  &__btn-wrapper
    order: 4
    align-self: flex-end

    @media screen and (max-width: 920px)
      display: flex
      justify-content: space-between
      gap: 10px
      margin-block-start: 35px
      align-self: unset

  &__next
    width: 220px
    height: 44px

    @media screen and (max-width: 920px)
      align-self: center

  &__again
    align-self: flex-end
    width: 220px
    height: 44px

    @media screen and (max-width: 920px)
      order: 4
      margin-top: 26px
      align-self: center

  &__step-icon
    --bottom-offset: 0px
    --left-offset: 0px
    --width-offset: 0px

    position: absolute
    left: calc(-160px + var(--left-offset))
    bottom: calc(-25px + var(--bottom-offset))
    max-width: calc(217px + var(--width-offset))

    @media screen and (max-width: 1300px)
      left: calc(-110px + var(--left-offset))
      width: calc(190px + var(--width-offset))

    @media screen and (max-width: 1190px)
      left: calc(-65px + var(--left-offset))
      width: calc(140px + var(--width-offset))

    @media screen and (max-width: 1120px)
      left: calc(-40px + var(--left-offset))
      width: calc(120px + var(--width-offset))

    @media screen and (max-width: 1070px)
      left: calc(-5px + var(--left-offset))
      width: calc(90px + var(--width-offset))

    @media screen and (max-width: 920px)
      position: static
      width: calc(103px + var(--width-offset))

    &.img-asol-3
      --left-offset: 30px

      @media screen and (max-width: 1190px)
        --width-offset: 10px
        --bottom-offset: 16px
        --left-offset: 27px

      @media screen and (max-width: 1120px)
        --width-offset: 35px

      @media screen and (max-width: 1070px)
        --width-offset: 50px
        --left-offset: 0px

    &.img-asol-4
      @media screen and (max-width: 1190px)
        --width-offset: 15px
        --left-offset: -10px

      @media screen and (max-width: 1120px)
        --width-offset: 20px

      @media screen and (max-width: 1070px)
        --width-offset: 20px

      @media screen and (max-width: 920px)
        --width-offset: 20px

    &.img-asol-5
      @media screen and (max-width: 1190px)
        --width-offset: 15px

      @media screen and (max-width: 1120px)
        --width-offset: 20px

      @media screen and (max-width: 1070px)
        --width-offset: 45px
        --left-offset: -6px

      @media screen and (max-width: 920px)
        --width-offset: 20px

  &__test-result
    margin-top: 25px

    &-smile
      font-size: 48px
      font-weight: 600
      line-height: 1
      margin-bottom: 67px

    &-text
      font-size: 18px
      font-weight: 700
      margin-bottom: 85px

      @media screen and (max-width: 920px)
        margin-bottom: 55px

.check
  &__label
    display: flex
    gap: 31px
    align-items: center
    cursor: pointer
    user-select: none

    @media screen and (max-width: 920px)
      gap: 15px

  &__input
    position: absolute
    opacity: 0
    pointer-events: none

  &__box
    width: 24px
    height: 24px
    border: 1px solid #C8C8C8
    border-radius: 4px
    display: inline-block
    transition: all .2s
    background: #FFFFFF
    box-shadow: inset 0 0 0 2px transparent
    position: relative

  &__input:focus-visible + .check__box
    outline: 2px solid #94A3B8
    outline-offset: 2px

  &__input:checked + .check__box
    border-color: var(--brand)
    background: var(--brand)

  &__input:checked + .check__box::after
    content: ""
    position: absolute
    left: 8px
    top: 3px
    width: 6px
    height: 12px
    border: 2px solid #FFFFFF
    border-top: 0
    border-left: 0
    transform: rotate(45deg)

  &__text
    font-size: 18px

    @media screen and (max-width: 920px)
      font-size: 16px

.progress
  &__list
    display: grid
    grid-template-columns: repeat(5, 1fr)
    grid-template-rows: auto
    align-items: center
    gap: 25px
    padding: 14px 21px 12px 22px
    list-style: none
    border: 1px solid #C8C8C8
    border-radius: 4px
    width: fit-content
    background: #fff

    @media screen and (max-width: 920px)
      margin: 0 auto
      padding: 0
      border: unset
      gap: 10px

  &__item
    max-height: 60px
    aspect-ratio: 1 / 1
    border-radius: 50%
    background: #D9D9D9
    display: grid
    place-items: center
    overflow: hidden

  &__coin
    opacity: 0
    transform: rotate(0deg)
    transition: opacity 0.6s ease, transform 0.6s ease, scale 0.3s
    display: block
    object-fit: cover

    &[data-has="true"]
      opacity: 1
      transform: rotate(360deg)
      cursor: pointer

      &:hover
        scale: 1.2

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/school-test.vue